import { permissionGroupAdminApi } from '@/api/admin/permission-group';
import type { RootState } from '@/store';
import type { IThunkAPI } from '@/store/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { IClientPermissionRequest, IPermissionGroup, IPermissionGroupState } from '../types/types';

const initialState: IPermissionGroupState = {
  permissionGroupList: [],
};

export const getPermissionGroupList = createAsyncThunk<Array<IPermissionGroup>, number, IThunkAPI>(
  'get/permission/group/client/clientId/list',
  async (clientId, thunkAPI) => {
    try {
      const response = await permissionGroupAdminApi.getPermissionGroup(clientId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getPermissionGroupByClientAndPermissionIdList = createAsyncThunk<
  Array<IPermissionGroup>,
  IClientPermissionRequest,
  IThunkAPI
>('get/permission/group/client/clientId/permission/permissionId/list', async (permissionGroupRequest, thunkAPI) => {
  try {
    const response = await permissionGroupAdminApi.getPermissionGroupByClientAndPermissionId(permissionGroupRequest);
    return response.data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

export const savePermissionGroup = createAsyncThunk<unknown, IPermissionGroup, IThunkAPI>(
  'post/admin/permission/group/create',
  async (permissionGroup, thunkAPI) => {
    try {
      const response = await permissionGroupAdminApi.savePermissionGroup(permissionGroup);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const deletePermissionGroup = createAsyncThunk<unknown, IPermissionGroup, IThunkAPI>(
  'post/admin/permission/group/delete/clientId/groupId/groupLabel',
  async (permissionGroup, thunkAPI) => {
    try {
      const response = await permissionGroupAdminApi.deletePermissionGroup(permissionGroup);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const permissionGroupAdminSlice = createSlice({
  name: 'permissionGroupAdmin',
  initialState,
  reducers: {
    clearPermissionGroupList(state) {
      state.permissionGroupList = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getPermissionGroupList.fulfilled, (state, action) => {
        state.permissionGroupList = action.payload;
      })
      .addCase(getPermissionGroupByClientAndPermissionIdList.fulfilled, (state, action) => {
        state.permissionGroupList = action.payload;
      });
  },
});

// actions
export const { clearPermissionGroupList } = permissionGroupAdminSlice.actions;

// selectors
export const permissionGroupList = (state: RootState): IPermissionGroupState['permissionGroupList'] =>
  state.permissionGroupAdmin.permissionGroupList;

export default permissionGroupAdminSlice.reducer;
